export const PROGRAM_REGIONS = `
  query programRegions ($filter: FilterProgramRegionInput, $tenant_id: Int!) {
    programRegions(filter: $filter, tenant_id: $tenant_id) {
      id
      name
      region_order
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;
